import { IconWrapper } from '../runtime';
export default IconWrapper('a', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M3 13.4998L4.42163 10.0878M13 13.4998L11.5784 10.0878M4.42163 10.0878L7.72308 2.16437C7.82564 1.91822 8.17436 1.91822 8.27692 2.16437L11.5784 10.0878M4.42163 10.0878H11.5784",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});